// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__2HrvW","input":"Input_input__2kWcf","label":"Input_label__3P1Ma","error":"Input_error__306hH"};